import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCopy = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 20,
	viewBox: "0 0 18 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.2632 0.909091C13.2632 0.407014 12.8561 0 12.3541 0H1.89474C0.852632 0 0 0.818182 0 1.81818V13.5981C0 14.1213 0.424151 14.5455 0.947368 14.5455C1.47059 14.5455 1.89474 14.1213 1.89474 13.5981V2.81818C1.89474 2.2659 2.34245 1.81818 2.89474 1.81818H12.3541C12.8561 1.81818 13.2632 1.41117 13.2632 0.909091ZM16.1053 3.63636H5.68421C4.64211 3.63636 3.78947 4.45455 3.78947 5.45455V18.1818C3.78947 19.1818 4.64211 20 5.68421 20H16.1053C17.1474 20 18 19.1818 18 18.1818V5.45455C18 4.45455 17.1474 3.63636 16.1053 3.63636ZM16.1053 17.1818C16.1053 17.7341 15.6575 18.1818 15.1053 18.1818H6.68421C6.13193 18.1818 5.68421 17.7341 5.68421 17.1818V6.45455C5.68421 5.90226 6.13193 5.45455 6.68421 5.45455H15.1053C15.6575 5.45455 16.1053 5.90226 16.1053 6.45455V17.1818Z",
		fill: "current"
	})
});
export default SvgCopy;
